var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.292 2.52278L14.2921 2.5227C14.6999 2.11493 14.6999 1.4636 14.2921 1.05583C13.8843 0.648057 13.233 0.648057 12.8252 1.05583L5.12922 8.75181L2.5227 6.14529C2.11493 5.73752 1.4636 5.73752 1.05583 6.14529C0.648057 6.55306 0.648057 7.20439 1.05583 7.61216L4.38784 10.9442C4.79558 11.3519 5.4548 11.3519 5.86258 10.9443C5.86261 10.9442 5.86263 10.9442 5.86266 10.9442L14.292 2.52278Z",
    fill: "#00FFB0",
    stroke: "#00FFB0",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.a26302aa40a38efff8e2219fd25a21c5.svg";
export { ForwardRef as ReactComponent };